"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _clsx = _interopRequireDefault(require("clsx"));
var _commonCta = require("@mmc/common-cta");
var _vinRecallLookup = _interopRequireDefault(require("./vin-recall-lookup.css"));
var _vinRecallSearch = _interopRequireDefault(require("./vin-recall-search"));
var randomIdModifier = 999;
var inputId = Math.floor(Math.random() * randomIdModifier);
var whereCanFindId = Math.floor(Math.random() * randomIdModifier);
var VinRecallLookup = function VinRecallLookup(_ref) {
  var _vinImages$0$image, _vinImages$0$image2, _vinImages$1$image, _vinImages$1$image2, _vinImages$2$image, _vinImages$2$image2;
  var theme = _ref.theme,
    data = _ref.data;
  var title = data.title,
    dealerHeadline = data.dealerHeadline,
    dealerDescription = data.dealerDescription,
    findvinHeadline = data.findvinHeadline,
    vinImages = data.vinImages,
    cta1 = data.cta1,
    vindealerhelpList = data.vindealerhelpList,
    text = data.text,
    findvinDescription = data.findvinDescription,
    showDealerInfo = data.showDealerInfo;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _vinRecallLookup["default"].vinRecallLookup + " " + theme.marginBottom80 + " " + theme.marginTop50
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + theme['container-fluid']
  }, (text || title) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['center-xs'] + " " + _vinRecallLookup["default"].headWrapper
  }, title && /*#__PURE__*/_react["default"].createElement("h2", {
    className: theme.headingOne + " " + theme.marginBottom20
  }, title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "" + theme.introCopy
  }, text))), /*#__PURE__*/_react["default"].createElement(_vinRecallSearch["default"], {
    theme: theme,
    data: data,
    inputId: inputId,
    whereCanFindId: whereCanFindId
  }), showDealerInfo && /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row + " " + _vinRecallLookup["default"].contactDealer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + theme['col-xs-12']
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: theme.headingFour + " " + theme.marginBottom20
  }, dealerHeadline), /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.introCopy + " " + theme.marginBottom20
  }, dealerDescription)), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-sm-6']
  }, /*#__PURE__*/_react["default"].createElement("h5", {
    className: theme.headingFive + " " + theme.marginBottom10
  }, vindealerhelpList[0].header), /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.bodyCopy + " " + theme.marginBottom20
  }, vindealerhelpList[0].description), /*#__PURE__*/_react["default"].createElement("h5", {
    className: theme.headingFive + " " + theme.marginBottom10
  }, vindealerhelpList[2].header), /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.bodyCopy + " " + theme.marginBottom20
  }, vindealerhelpList[2].description)), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-sm-5'] + " " + theme['col-sm-offset-1']
  }, /*#__PURE__*/_react["default"].createElement("h5", {
    className: theme.headingFive + " " + theme.marginBottom10
  }, vindealerhelpList[1].header), /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.bodyCopy + " " + theme.marginBottom20
  }, vindealerhelpList[1].description)), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['center-xs'] + " " + theme.marginBottom80
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: {
      url: cta1.URL,
      label: cta1.label,
      priority: 'medium',
      openNewTab: true
    },
    classes: ["" + _vinRecallLookup["default"].headerLink]
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['container-fluid'] + " " + _vinRecallLookup["default"].whereCanIFindWrap
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + theme['col-xs-12']
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: theme.headingThree + " " + theme.marginBottom20 + " " + theme['center-xs'],
    id: whereCanFindId
  }, findvinHeadline), /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.introCopy + " " + theme.marginBottom20
  }, findvinDescription))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-sm-4'] + " " + _vinRecallLookup["default"].imageWrapper
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: (_vinImages$0$image = vinImages[0].image) == null ? void 0 : _vinImages$0$image.image,
    alt: (_vinImages$0$image2 = vinImages[0].image) == null ? void 0 : _vinImages$0$image2.altText
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.copyright + " " + theme.marginBottom20
  }, vinImages[0].description)), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-sm-4'] + " " + _vinRecallLookup["default"].imageWrapper
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: (_vinImages$1$image = vinImages[1].image) == null ? void 0 : _vinImages$1$image.image,
    alt: (_vinImages$1$image2 = vinImages[1].image) == null ? void 0 : _vinImages$1$image2.altText
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.copyright + " " + theme.marginBottom20
  }, vinImages[1].description)), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-sm-4'] + " " + _vinRecallLookup["default"].imageWrapper
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: (_vinImages$2$image = vinImages[2].image) == null ? void 0 : _vinImages$2$image.image,
    alt: (_vinImages$2$image2 = vinImages[2].image) == null ? void 0 : _vinImages$2$image2.altText
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.copyright + " " + theme.marginBottom20
  }, vinImages[2].description)))));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language
  };
};
VinRecallLookup.resourceType = function () {
  return 'CarSelector_1_0_0';
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(VinRecallLookup);